import { render, staticRenderFns } from "./LocationNotes.vue?vue&type=template&id=27c85644&scoped=true"
import script from "./LocationNotes.vue?vue&type=script&lang=js"
export * from "./LocationNotes.vue?vue&type=script&lang=js"
import style0 from "./LocationNotes.vue?vue&type=style&index=0&id=27c85644&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c85644",
  null
  
)

export default component.exports